// extracted by mini-css-extract-plugin
module.exports = {"footer":"Layout_footer__3mkvi"};